import { useEffect, useState } from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { useTranslation } from 'react-i18next'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { supabase } from '../../lib/supabase'
import { fonts } from '../../lib/theme'
import { useThemeColors } from '../../lib/useThemeColors'
import { legibleOn } from '../../lib/contrast'
import { SPECIAL_BADGES } from '../personAvatarConfig'
import { Card, SectionLabel } from '../ui'

// Maglie speciali di lega (iridata, europea, Coppa del Mondo) vinte da un giocatore: quella che veste adesso e quelle passate.
// Non compare se non ne ha mai avute.
export default function SpecialJerseysCard({ leagueId, userId, leagueName }) {
  const tc = useThemeColors()
  const { t, i18n } = useTranslation()
  const [rows, setRows] = useState([])

  useEffect(() => {
    if (!leagueId || !userId) return
    let cancelled = false
    supabase.from('fact_user_special_jersey')
      .select('jersey_code, awarded_at, is_current, dim_race(name, year)')
      .eq('id_league', leagueId).eq('id_user', userId)
      .order('awarded_at', { ascending: false })
      .then(({ data }) => { if (!cancelled) setRows(data ?? []) })
    return () => { cancelled = true }
  }, [leagueId, userId])

  if (rows.length === 0) return null
  const fmt = (d) => new Date(d).toLocaleDateString(i18n.language, { day: 'numeric', month: 'long', year: 'numeric' })

  return (
    <Card style={{ marginBottom: 0 }}>
      <SectionLabel mb={10}>{t('badges.special_title')}</SectionLabel>
      <View style={{ gap: 8 }}>
        {rows.map((r, i) => {
          const colors = SPECIAL_BADGES[r.jersey_code]?.colors ?? []
          const color = colors[Math.min(1, colors.length - 1)] ?? tc.rosa
          return (
            <View key={`${r.jersey_code}-${i}`} style={[s.row, { backgroundColor: tc.bgCard2, borderColor: r.is_current ? color + '88' : tc.border }]} accessible>
              <MaterialCommunityIcons name="tshirt-crew" size={30} color={color} />
              <View style={{ flex: 1, gap: 2 }}>
                <Text style={[s.name, { color: tc.text }]} numberOfLines={1}>{t(`person.view_${r.jersey_code}`)}</Text>
                <Text style={[s.sub, { color: tc.textMuted }]} numberOfLines={2}>
                  {r.is_current ? t(`person.${r.jersey_code}_since`, { league: leagueName ?? '', date: fmt(r.awarded_at) }) : `${r.dim_race?.name ?? ''} · ${fmt(r.awarded_at)}`}
                </Text>
              </View>
              {r.is_current && <Text style={[s.now, { color: legibleOn(color, tc.bgCard2, 3) }]}>{t('badges.special_now')}</Text>}
            </View>
          )
        })}
      </View>
    </Card>
  )
}

const s = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 12, borderWidth: 1, borderRadius: 12, padding: 12 },
  name: { fontFamily: fonts.condensedBold, fontSize: 15 },
  sub: { fontSize: 12, lineHeight: 16 },
  now: { fontFamily: fonts.condensedBold, fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.5 },
})
